// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';

// Reducers
import authReducer from './slices/branch/authSlice';
import userProfileReducer from './slices/branch/userProfileSlice';
import personalLoanReducer from './slices/Loans/PersonalLoanSlice';
import customerReducer from './slices/Customer/CreateCustomerSlice';
import customerReportReducer from './slices/Customer/customerReportSlice';
import applyLoanReducer from './slices/loan/ApplyLoanSlice';
import loanReportReducer from './slices/loan/loanReportSlice';
import customerKycReducer from './slices/Customer/CustomerKycSlice';
import permissionManagerReducer from './slices/branch/permissionManagerSlice';
import permissionReducer from './slices/permissionSlice';
import kycUploadreducer from './slices/kycuploadslice';

// ✅ Import Loan KYC slice
import loanKycReducer from './slices/loan/loanKycSlice';

// ✅ Import Loan EMI slice
import loanEmiReducer from './slices/loan/loanEmiSlice';
import payLoanEmiReducer from '../redux/slices/loan/PayLoanEmiSlice'; // ✅ New Pay Loan EMI slice

// ✅ Import Saving slice
import savingReducer from './slices/bank/SavingSlice'; 

const store = configureStore({
  reducer: {
    auth: authReducer,
    userProfile: userProfileReducer,
    personalLoan: personalLoanReducer,
    customer: customerReducer,
    customerReport: customerReportReducer,
    applyLoan: applyLoanReducer,
    loanReport: loanReportReducer,
    customerKyc: customerKycReducer,
    permissions: permissionReducer,
    permissionManager: permissionManagerReducer,

    // ✅ Loan KYC
    loanKyc: loanKycReducer,
    documents: kycUploadreducer,

    // ✅ Loan EMI
    loanEmi: loanEmiReducer,
    payLoanEmi: payLoanEmiReducer,
    payLoanEmi: payLoanEmiReducer,

     // ✅ banking
    savingSlice: savingReducer

  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
